import { toggleButtonProps, ToggleButton } from './chunk-X4HT4ZZN.js';
import { Icon } from './chunk-3QHO3DXX.js';
import { isTrackCaptionKind } from './chunk-GHCUWWGF.js';
import { $ariaBool } from './chunk-EVP5E6AO.js';
import { setARIALabel } from './chunk-Z6A4GYXE.js';
import { useMedia } from './chunk-ZIBTY3GT.js';
import { $$_create_component } from 'maverick.js/dom';
import { defineElement } from 'maverick.js/element';
import { closedCaptionsOnPaths, closedCaptionsPaths } from 'media-icons';

var CaptionButton = class extends ToggleButton {
  constructor() {
    super(...arguments);
    this.la = "toggleCaptions";
  }
  onAttach(el) {
    this.a = useMedia();
    this.u = this.U.bind(this);
    super.onAttach(el);
    setARIALabel(el, this.F.bind(this));
    this.setAttributes({
      "aria-hidden": $ariaBool(this.v.bind(this))
    });
  }
  G(event) {
    this.a.remote.toggleCaptions(event);
  }
  U() {
    const { textTrack } = this.a.$store, track = textTrack();
    return !!track && isTrackCaptionKind(track);
  }
  v() {
    const { textTracks } = this.a.$store;
    return textTracks().filter(isTrackCaptionKind).length == 0;
  }
  F() {
    const { textTrack } = this.a.$store;
    return textTrack() ? "Closed-Captions Off" : "Closed-Captions On";
  }
  render() {
    return [
      $$_create_component(Icon, { paths: closedCaptionsOnPaths, slot: "on" }),
      $$_create_component(Icon, { paths: closedCaptionsPaths, slot: "off" })
    ];
  }
};
CaptionButton.el = defineElement({
  tagName: "media-caption-button",
  props: toggleButtonProps
});

export { CaptionButton };
